import styled from "styled-components";

import { tokens } from "@swiggy-private/dls-web-common/dist/components/tokens";

export const Container = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 100%;
    height: 100%;
    --color-background_Add_Button: ${tokens.colors.slate00};
    --color-border_Subtle_Secondary: ${tokens.colors.slateAlpha30};
`;
